import React, { useContext } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

import MyContext from "./Context/Context";

import check from "../assets/icons/check.svg"

function Flash() {
    const { toggleFlash, flashMessage } = useContext(MyContext);

    return (
        <AnimatePresence>
        {
            toggleFlash && (
                <motion.div 
                    key="modal"
                    initial={{ opacity: 0, transform: "scale(0.8)" }}
                    animate={{ opacity: 1, transform: "scale(1)" }}
                    exit={{ opacity: 0 }}
                    className="flash">
                    <div className="flash__box">
                        <img src={check} alt="check" style={{maxHeight: "30px", marginRight: "10px"}}/>
                        { flashMessage }
                    </div>
                </motion.div>
            )
        }
        </AnimatePresence>
    )
}

export default Flash
